"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_NOTIFICATIONS_COPY = void 0;
exports.USER_NOTIFICATIONS_COPY = {
    DAYS_AGO: (days) => `${days} days ago`,
    DAY_AGO: 'A day ago',
    EMPTY: 'No Notifications',
    HOURS_AGO: (hours) => `${hours} hours ago`,
    HOUR_AGO: 'An hour ago',
    LESS_MINUTE_AGO: 'Less than a minute ago',
    MINUTES_AGO: (minutes) => `${minutes} minutes ago`,
    MINUTE_AGO: 'A minute ago',
    WEEK_AGO: 'A week ago'
};
//# sourceMappingURL=USER_NOTIFICATIONS.js.map